import { render } from "./LoginPopupLinks.vue?vue&type=template&id=37f36c38&scoped=true"
import script from "./LoginPopupLinks.vue?vue&type=script&lang=js"
export * from "./LoginPopupLinks.vue?vue&type=script&lang=js"

import "./LoginPopupLinks.vue?vue&type=style&index=0&id=37f36c38&scoped=true&lang=css"

import exportComponent from "D:\\TeamCity\\BuildAgent2\\work\\1bfd74eb4d5fb108\\FamilyPortalApp\\familyportal-app\\src\\familyportal-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f36c38"]])

export default __exports__